var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Grid',{attrs:{"row-gap":"m","col":"12"}},[_vm._t("title"),_c('div',{staticClass:"fields"},[_vm._t("fields")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }